import { render, staticRenderFns } from "./verisurehuishoudens.vue?vue&type=template&id=869514e0&scoped=true"
import script from "./verisurehuishoudens.vue?vue&type=script&lang=js"
export * from "./verisurehuishoudens.vue?vue&type=script&lang=js"
import style0 from "./verisurehuishoudens.vue?vue&type=style&index=0&id=869514e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869514e0",
  null
  
)

export default component.exports